import { render, staticRenderFns } from "./OrderDetailList.vue?vue&type=template&id=039333a8&scoped=true&"
import script from "./OrderDetailList.vue?vue&type=script&lang=js&"
export * from "./OrderDetailList.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailList.vue?vue&type=style&index=0&id=039333a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039333a8",
  null
  
)

export default component.exports